import { defineStore } from 'pinia';
import LabelsEntity from '@/v2/modules/whatsapp/entities/labels';
import { Alert } from '@/v2/plugins/alert';
import { t } from '@/locales/index';

export const useLabelStore = defineStore('WhatsAppLabelStore', {
	state: () => ({
		loading: false,
		loadingPage: false,
        loadingDelete: false,
        loadingList: false,
        list: [],
		form: {
			name: '',
		},
	}),
	actions: {
        async fetch() {
            this.loadingList = true;
            try {
                const resp = await LabelsEntity.fetch();
                this.list = resp?.data ?? [];
            } finally {
                this.loadingList = false;
            }
        },
		async create(id) {
			this.loading = true;
			try {
				if (id) await LabelsEntity.update(id, this.form);
				else await LabelsEntity.create(this.form);
				Alert.success(t(id ? 'updatedSuccessfully' : 'createdSuccessfully'));
				return true;
			} catch (error) {
				Alert.error(error?.response?.data?.message);
			} finally {
				this.loading = false;
			}
		},
        async get(id) {
            this.loadingPage = true;

            try {
                try {
                    const resp = await LabelsEntity.get(id);
                    const data = resp?.data?.result?.label;

                    this.form['name'] = data?.name;
                } catch (error) {
                    console.error(error);
                } finally {
                    this.loadingPage = false;
                }
            } catch (error) {
                console.error(error);
                this.loadingPage = false;
            }
        },
        async remove(id) {
            this.loadingDelete = true;

            try {
                const resp = await LabelsEntity.remove(id);
                this.fetch();
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingDelete = false;
            }
        },
        reset(){
            this.form = {
                name : ''
            }
        }
	},
});
